// Angular imports
import { HttpClient } from '@angular/common/http';

// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';

// Rxjs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { plainToClass } from 'class-transformer';

// Constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';

// Model imports
import { DynamicDashboardEntry } from '../_model/dynamic-dashboard-entry';
import { SharedWorkspaceParametersDto } from '../_model/shared-workspace-parameters-dto';
import { SharedWorkspaceResultDto } from '../_model/shared-workspace-result-dto';

export abstract class SystemDashboardsFactory {
    constructor(
        protected readonly httpClient: HttpClient,
        protected readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    abstract getDashboardCategoryCode(): 'USR' | 'CB' | 'COMM' | 'PROP' | 'CCB';

    getSystemDashboards(clearCache: boolean): Observable<DynamicDashboardEntry[]> {
        return this.getDashboards(true, clearCache);
    }

    getSharedDashboards(clearCache: boolean): Observable<DynamicDashboardEntry[]> {
        return this.getDashboards(false, clearCache);
    }

    private getDashboards(isSystem = false, clearCache = false): Observable<DynamicDashboardEntry[]> {
        const params = new SharedWorkspaceParametersDto();
        params.clearCache = clearCache;
        params.isSystemType = isSystem;
        params.categoryCode = this.getDashboardCategoryCode();
        const url = `${URLConstants.ccUserBaseApiUrl}/sharedworkspace?${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(
                map((response: any[]) =>
                    plainToClass(SharedWorkspaceResultDto, response).map((r) =>
                        DynamicDashboardEntry.fromSharedWorkspace(r)
                    )
                )
            );
    }
}
